import { SESSION_TYPES } from "@common/constants/sessionConstants";

export const isCleaningSession = session =>
  session &&
  (session.session_type === SESSION_TYPES.SESSION_TYPE_CLEAN_MINIBREW ||
    session.session_type === SESSION_TYPES.SESSION_ACID_CLEAN_MINIBREW);
